import classnames from 'classnames/bind'
import React, { useState } from 'react'

import { useIsomorphicLayoutEffect } from '@unlikelystudio/react-hooks'

import Cta, { CtaProps } from '~/components/Cta'
import Curve from '~/components/Curve'
import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import RichText, { RichTextBlock } from '~/components/RichText'
import Video from '~/components/Video'

import { useNavigation } from '~/providers/NavigationProvider'
import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface HeroMainProps {
  className?: string
  label?: RichTextBlock[]
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  primaryCta?: CtaProps
  secondaryCta?: CtaProps
  image?: ImageProps
  imageMobile?: ImageProps
  video?: string
  videoMobile?: string
  layout?: 'regular' | 'big'
  curveColor?: '#ccc2ff' | '#cedbf0'
}
/**
 * Hero main slice
 * @param props
 * @returns Slice
 */
function HeroMain({
  layout,
  className,
  label,
  title,
  text,
  primaryCta,
  secondaryCta,
  image,
  imageMobile,
  video,
  videoMobile,
  curveColor,
}: HeroMainProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const labelStyle = useStyle({ textPreset: 'text-paragraph' })
  const titleStyle = useStyle({ textPreset: 'title-page' })
  const textStyle = useStyle({
    textPreset: 'text-paragraph',
    color: 'blue-bayoux',
  })

  return (
    <section className={cx(className, css.HeroMain, css?.[layout])}>
      <Curve
        className={cx(css.curve, css.hideOnSmallScreen)}
        type="header"
        color={curveColor ? curveColor : '#ccc2ff'}
      />
      <div className={css.containerImage}>
        <div className={css.assetContainer}>
          <Curve
            className={cx(css.curve, css.hideOnLargeScreen)}
            type="header"
          />
          {image && (
            <ImageWithPlaceHolder
              className={cx(css.hideOnSmallScreen, css.image)}
              layout="fill"
              objectFit="contain"
              priority={true}
              {...image}
            />
          )}
          {imageMobile && (
            <ImageWithPlaceHolder
              className={cx(css.hideOnLargeScreen, css.image)}
              layout="responsive"
              priority={true}
              {...imageMobile}
            />
          )}
        </div>
      </div>
      <div className={css.content}>
        <div className={cx(css.grid, gridStyle)}>
          {label?.length > 0 && (
            <RichText className={cx(css.label, labelStyle)} render={label} />
          )}
          {title && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          {text && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
          <div className={cx(css.ctas)}>
            {primaryCta && <Cta className={css.cta} {...primaryCta} />}
            {secondaryCta && <Cta className={css.cta} {...secondaryCta} />}
          </div>
        </div>
      </div>
    </section>
  )
}

HeroMain.defaultProps = {}

export default HeroMain
